"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NewDialog;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _NotifyIcon = _interopRequireDefault(require("../NotifyIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * @typedef {Object} NewDialogProps
 * @property {Boolean} open define if the Dialog will be open
 * @property {Boolean} canSave define if the Dialog can be saved
 * @property {Boolean} isSaving define if the Dialog is saving
 * @property {Function} handleClose handle close method for default actions
 * @property {Function} handleCancel handle cancel method for default actions
 * @property {Function} handleOk handle ok method for default actions
 * @property {String} title Title of Dialog
 * @property {String} subTitle Subtitle of Dialog
 * @property {JSX.Element} content Content of Dialog, see {@link JSX.Element}
 * @property {String} cancelCaption Cancel button caption
 * @property {String} okCaption Save button caption
 * @property {JSX.Element} actionBar Content of action bar if you don't want to use the default, see {@link JSX.Element}
 * @property {String} minHeight See {@link https://developer.mozilla.org/docs/Web/CSS/min-height}
 * @property {String} maxHeight See {@link https://developer.mozilla.org/docs/Web/CSS/max-height}
 * @property {String} minWidth See {@link https://developer.mozilla.org/docs/Web/CSS/min-width}
 * @property {String} maxWidth See {@link https://developer.mozilla.org/docs/Web/CSS/max-width}
 * @property {'body' | 'paper'} [scroll='paper'] scroll Determine the container for scrolling the dialog
 * @property {String} paddingXContent Horizontal padding on the left and right of content
 * @property {String} paddingYContent Vertical padding on the bottom and top of content
 * @property {Boolean} displayActionBar See {@link https://developer.mozilla.org/docs/Web/CSS/display}
 * @property {String} justifyContentActionBar See {@link
 * https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content}
 * @property {String} className Class name for Dialog
 * @property {Object} dialogProps Props to be set on the Dialog component.
 * See {@link https://mui.com/api/dialog/}
 */

/**
 * Create a dialog following the design system
 * @param {NewDialogProps} props
 * @returns {Dialog}
 */
function NewDialog(_ref) {
  var open = _ref.open,
    canSave = _ref.canSave,
    isSaving = _ref.isSaving,
    handleClose = _ref.handleClose,
    handleCancel = _ref.handleCancel,
    handleOk = _ref.handleOk,
    title = _ref.title,
    subTitle = _ref.subTitle,
    content = _ref.content,
    cancelCaption = _ref.cancelCaption,
    okCaption = _ref.okCaption,
    actionBar = _ref.actionBar,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    scroll = _ref.scroll,
    paddingXContent = _ref.paddingXContent,
    paddingYContent = _ref.paddingYContent,
    displayActionBar = _ref.displayActionBar,
    justifyContentActionBar = _ref.justifyContentActionBar,
    className = _ref.className,
    _ref$dialogProps = _ref.dialogProps,
    dialogProps = _ref$dialogProps === void 0 ? {} : _ref$dialogProps;
  function ActionBar() {
    if (actionBar) {
      return actionBar;
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
      sx: {
        minHeight: 56,
        minWidth: 115
      },
      disabled: isSaving,
      onClick: handleCancel,
      variant: "text",
      color: "error"
    }, cancelCaption), /*#__PURE__*/_react["default"].createElement(_material.Button, {
      sx: {
        minHeight: 56,
        minWidth: 115
      },
      disabled: isSaving || !canSave,
      onClick: handleOk,
      variant: "contained"
    }, okCaption, isSaving && /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
      sx: {
        marginLeft: 1,
        fontSize: '1.125rem'
      },
      size: 18
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, _extends({
    className: className,
    PaperProps: {
      sx: {
        minHeight: minHeight,
        maxHeight: maxHeight || '100vh',
        minWidth: minWidth,
        maxWidth: maxWidth || '100vw'
      }
    },
    scroll: scroll || 'paper',
    open: open,
    onClose: handleClose,
    disableEscapeKeyDown: true
  }, dialogProps), /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
    sx: {
      fontSize: '1.300rem',
      pl: paddingXContent,
      pt: '2rem',
      pb: '2px',
      borderTop: '0.5rem solid #2baca3'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      fontSize: {
        xs: 24,
        sm: 26
      },
      fontWeight: '550'
    }
  }, title), /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    onClick: handleClose,
    style: {
      position: 'absolute',
      right: 1,
      top: 12
    }
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    iconName: "close",
    color: "primary"
  }))), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
    sx: {
      fontSize: 28,
      pl: paddingXContent,
      pr: paddingXContent,
      pb: '1rem'
    }
  }, subTitle && /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, null, subTitle), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    noValidate: true,
    sx: {
      py: paddingYContent,
      width: '100%'
    }
  }, content)), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
    sx: {
      display: displayActionBar,
      justifyContent: justifyContentActionBar,
      backgroundColor: '#f7f7fa',
      borderTop: '1px solid #b9b9bc',
      padding: '1rem 2rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(ActionBar, null)));
}
NewDialog.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  canSave: _propTypes["default"].bool,
  isSaving: _propTypes["default"].bool,
  handleClose: _propTypes["default"].func.isRequired,
  handleCancel: _propTypes["default"].func,
  handleOk: _propTypes["default"].func,
  title: _propTypes["default"].string.isRequired,
  subTitle: _propTypes["default"].string,
  content: _propTypes["default"].element,
  cancelCaption: _propTypes["default"].string,
  okCaption: _propTypes["default"].string,
  actionBar: _propTypes["default"].element,
  minHeight: _propTypes["default"].string,
  maxHeight: _propTypes["default"].string,
  minWidth: _propTypes["default"].string,
  maxWidth: _propTypes["default"].string,
  scroll: _propTypes["default"].string,
  paddingXContent: _propTypes["default"].string,
  paddingYContent: _propTypes["default"].string,
  displayActionBar: _propTypes["default"].string,
  justifyContentActionBar: _propTypes["default"].string,
  className: _propTypes["default"].string,
  dialogProps: _propTypes["default"].shape({
    'aria-describedby': _propTypes["default"].string,
    'aria-labelledby': _propTypes["default"].string,
    BackdropComponent: _propTypes["default"].elementType,
    BackdropProps: _propTypes["default"].shape({}),
    children: _propTypes["default"].node,
    classes: _propTypes["default"].shape({}),
    className: _propTypes["default"].string,
    disableEscapeKeyDown: _propTypes["default"].bool,
    fullScreen: _propTypes["default"].bool,
    fullWidth: _propTypes["default"].bool,
    maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), _propTypes["default"].string]),
    onBackdropClick: _propTypes["default"].func,
    onClose: _propTypes["default"].func,
    open: _propTypes["default"].bool,
    PaperComponent: _propTypes["default"].elementType,
    PaperProps: _propTypes["default"].shape({}),
    scroll: _propTypes["default"].oneOf(['body', 'paper']),
    sx: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({}), _propTypes["default"].bool])), _propTypes["default"].func, _propTypes["default"].shape({})]),
    TransitionComponent: _propTypes["default"].elementType,
    transitionDuration: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
      appear: _propTypes["default"].number,
      enter: _propTypes["default"].number,
      exit: _propTypes["default"].number
    })]),
    TransitionProps: _propTypes["default"].shape({})
  })
};
NewDialog.defaultProps = {
  canSave: true,
  isSaving: false,
  handleCancel: function handleCancel() {},
  handleOk: function handleOk() {},
  subTitle: undefined,
  content: undefined,
  cancelCaption: '',
  okCaption: '',
  actionBar: undefined,
  minHeight: undefined,
  maxHeight: undefined,
  minWidth: undefined,
  maxWidth: undefined,
  scroll: 'paper',
  paddingXContent: '3rem',
  paddingYContent: '2rem',
  displayActionBar: undefined,
  justifyContentActionBar: undefined,
  className: undefined,
  dialogProps: {}
};